import { render, staticRenderFns } from "./tenantAdmin.vue?vue&type=template&id=002f5ca0&scoped=true"
import script from "./tenantAdmin.vue?vue&type=script&lang=js"
export * from "./tenantAdmin.vue?vue&type=script&lang=js"
import style0 from "./tenantAdmin.vue?vue&type=style&index=0&id=002f5ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f5ca0",
  null
  
)

export default component.exports